import axios from 'axios';
// import Thousandseperator from '../../../js/filters/Thousandseperator';
// import Slick from 'vue-slick';
import Thousandseperator from '../../../../../js/filters/Thousandseperator';

export default {
  props: {
    showDealerMarkup: {
      default: false,
      type: Boolean,
      required: false,
    },
    sortOption:{
      default: '',
      type: String
    },
    /**mega menu dynamic section loader used as mixin for menuPreowned component */
    setLoading:{
      type: Function,
      required: false,
      default: () => (status) => console.log(status),
    }
  },
  data() {
    return {
      isSportz: false,
      headerLabel: window.headerLabel !== '' ? window.headerLabel : 'Pre-Owned Vehicle Specials',
      isDealerGroup: window.isDealerGroup,
      isOpenNewVdpOnOwnerWebsite: window.OpenNewVdpOnOwnerWebsite,
      isOpenUsedVdpOnOwnerWebsite: window.OpenUsedVdpOnOwnerWebsite,
      slickOptions: {
        infinite: true,
        slidesToShow: 6,
        slidesToScroll: 1,
        dots: false,
        adaptiveHeight: true,
        autoplay: false,
        autoplaySpeed: 3000,
        responsive: [
          {
            breakpoint: 1441,
            settings: {
              slidesToShow: 5,
              slidesToScroll: 1,
              infinite: true,
              dots: true,
            },
          },
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
              infinite: true,
              dots: true,
            },
          },
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
            },
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
        nextArrow: `<em class="primaryicon-right-arrow bgcolor-primary" style="color:#cccccc;cursor:pointer;z-index:1"></em>`,
        prevArrow: `<em class="primaryicon-left-arrow" style="cursor:pointer;z-index:1"></em>`,
      },
      showPayment: window.priceType === '2',
      vehicles: '',
      discountedPrice: 0,
      // sortOption: window.preOwnedSpecialsSort,
      preOwnedPriceType: window.preOwnedPriceType === '2',
      FilteredVehicles: '',
    };
  },
  components: {
    // Slick,
  },
  // filters: {
  //   Thousandseperator,
  // },
  mounted() {
    this.setLoading(true);
    axios
    .get(
      `${window.ApiBaseUrl}/DealerGroup/GetAllDealerPreOwnedSpecials?accountId=${window.accountId}&campaignid=${window.campaignId}`
    )
    .then((response) => {
      this.setLoading(false);
      let vehicleData = response.data;

      // pushing discount property into vehicle object.
      this.vehicles = vehicleData.map((vehicleInfo) => {
        let discount = vehicleInfo.msrp - vehicleInfo.sellingPrice;

        if (discount < 0 && this.showDealerMarkup) {
          discount = Math.abs(discount);
        }

        return {
          ...vehicleInfo,
          discountPrice: discount,
        };
      });
      this.FilteredVehicles = this.vehicles;
      this.sortVehicles();
    })
    .catch(function (error) {
      this.setLoading(false);
      console.log(error);
    });

    if (window.accountId === '26408') {
      this.isSportz = true;
    }

  },
  methods: {
    thousandSeparator(value){
      return Thousandseperator(value);
    },
    frameVdpUrl(vehicle) {
      let url =
        `/viewdetails/${vehicle.type}/${vehicle.vin}/${vehicle.year}${vehicle.make}${vehicle.model}${vehicle.body}`.toLowerCase();

      if (this.isOpenUsedVdpOnOwnerWebsite && this.isDealerGroup && vehicle.url) {
        return `https://${vehicle.url}` + url;
      } else {
        return `${window.baseUrl}` + url;
      }
    },
    goToVdpUrl(vehicle) {
      window.location = this.frameVdpUrl(vehicle);
    },
    sortVehicles(){
      if (this.sortOption !== '') {
        let key = '';
        switch (this.sortOption) {
          case 'Age':
            key = 'dateInStock';
            break;

          case 'Mileage':
            key = 'miles';
            break;
          case 'Price':
            key = 'sellingPrice';
            break;
        }
        if (key) {
          this.FilteredVehicles.sort(function (a, b) {
            let x = a[key];
            let y = b[key];
            if (x < y) {
              return -1;
            } else if (x > y) {
              return 1;
            } else {
              return 0;
            }
          });
        } else {
          if (this.sortOption === 'Manufacturer') {
            this.sortVehiclesByManufacturer();
          }
        }
      }
    },
    sortVehiclesByManufacturer() {
      let makeVehicleDetails = [];
      let otherVehicleDetails = [];
      for (let vehicle of this.FilteredVehicles) {
        if (vehicle.make.toLowerCase() === window.make.toLowerCase()) {
          makeVehicleDetails.push(vehicle);
        } else {
          otherVehicleDetails.push(vehicle);
        }
      }
      this.FilteredVehicles = [...makeVehicleDetails, ...otherVehicleDetails];
    },
  },
};
